<section class="w-full bg-white lg:px-26 px-5 lg:pb-16 pb-10">
  <div class="mx-auto">
    <h2
      class="font-bold text-[#101010] lg:text-[32px] text-2xl lg:leading-13.5 leading-normal lg:mb-7.5 mb-6">
      Browse assets by keywords
    </h2>

    <!-- Category tabs + Top/Trending tabs -->
    <div
      class="flex max-md:flex-col lg:items-end items-start justify-between gap-4 lg:mb-6 mb-6 border-b border-[#EFEFF1]"
    >
      <div class="max-lg:min-w-0 max-lg:w-full max-lg:overflow-x-auto max-lg:overflow-y-hidden [-webkit-overflow-scrolling:touch]">
        <ul
          class="flex flex-nowrap w-max lg:w-full text-base font-medium text-[#636363] lg:leading-5 leading-normal font-Inter gap-6"
        >
          @for (item of categoryTabs; track $index) {
            <li
              class="cursor-pointer shrink-0 lg:pb-4 pb-2 text-nowrap"
              (click)="setTab(item)"
              [ngClass]="activeClass(item)"
            >
              {{ item }}
            </li>
          }
        </ul>
      </div>

      <ul class="flex flex-wrap shrink-0 items-center gap-2 lg:mb-4 mb-2">
        @for (type of searchTypes; track type) {
          <li
            class="cursor-pointer shrink-0 text-nowrap rounded-full border px-4.5 py-2.25 font-Inter font-medium text-[13px] leading-normal transition-colors duration-150"
            (click)="onSelectSearchType(type)"
            [ngClass]="searchTypeClass(type)"
          >
            {{ type }}
          </li>
        }
        <!-- <li
          class="py-2.25 px-4.5 shrink-0 font-medium text-[13px] leading-normal text-themeBlackTwo border border-[#E3E3E7] rounded-full flex items-center cursor-pointer relative"
          (click)="toggleDropdown(searchLevelDropdownId, $event)"
        >
          <span>{{
            selectedsearchLevel !== 'None' ? (selectedsearchLevel | titlecase) : 'Individual'
          }}</span>
          <img
            src="../../../../../../assets/theme/images/logo/arrow-down-black.svg"
            class="ms-1.5 transition-transform duration-200"
            [ngClass]="isDropdownVisible(searchLevelDropdownId) ? 'rotate-180' : 'rotate-0'"
            alt="arrow"
          />
          <ul
            class="absolute w-57.25 top-11 max-w-60 overflow-hidden rounded-2xl bg-white shadow-lg p-3 ease-in-out duration-200 opacity-0 z-40"
            [ngClass]="dropdownPanelClasses(searchLevelDropdownId)"
          >
            <li
              class="{{
                searchLevelEnum.Individual === selectedsearchLevel ||
                'None' === selectedsearchLevel
                  ? 'bg-[#eeeeee] rounded-md'
                  : ''
              }}"
            >
              <a
                (click)="onSelectSearchLevel(searchLevelEnum.Individual); $event.stopPropagation()"
                class="p-2.5 flex items-center w-full text-[14px] leading-5"
                >{{ searchLevelEnum.Individual }}</a
              >
            </li>
            <li
              class="{{
                searchLevelEnum.Pack === selectedsearchLevel ? 'bg-[#eeeeee] rounded-md' : ''
              }}"
            >
              <a
                (click)="onSelectSearchLevel(searchLevelEnum.Pack); $event.stopPropagation()"
                class="p-2.5 flex items-center w-full text-[14px] leading-5"
                >{{ searchLevelEnum.Pack }}</a
              >
            </li>
            <div class="border-b border-themeBonJour my-2"></div>
            <li class="flex items-center justify-between">
              <a class="p-2.5 flex items-center text-[14px] leading-5"></a>
              <span
                class="p-2.5 flex items-center text-[14px] leading-5 cursor-pointer"
                (click)="onSelectSearchLevel(filterOptionsEnum.None); $event.stopPropagation()"
                >Clear</span
              >
            </li>
          </ul>
        </li> -->
      </ul>
    </div>

    <!-- Keyword grid: 6 → 4 → 2 columns -->
    @if (loading()) {
      <div
        class="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-x-4 lg:gap-x-6 gap-y-3 lg:gap-y-4"
      >
        @for (item of keywordLoaderItems; track item) {
          <div class="h-5 w-full max-w-40 bg-gray-200 rounded animate-pulse"></div>
        }
      </div>
    } @else {
      <div
        class="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-x-4 lg:gap-x-6 gap-y-3 lg:gap-y-4"
      >
        @for (keyword of visibleKeywords; track $index) {
          <a
            [routerLink]="getKeywordLink(keyword)"
            [queryParams]="getKeywordQueryParams()"
            class="font-Inter font-normal text-sm lg:text-base leading-normal text-[#404040] hover:text-[#101010] hover:underline transition-colors duration-150"
            [title]="displayKeyword(keyword)"
          >
            {{ displayKeyword(keyword) }}
          </a>
        }
        <a
          [routerLink]="getViewMoreLink()"
          class="font-Inter font-medium text-sm lg:text-base leading-normal text-[#101010] hover:underline truncate"
        >
          View More
        </a>
      </div>
    }
  </div>
</section>
